(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('activityAddAttachment', activityAddAttachmentComponent);

    function activityAddAttachmentComponent(ActivitiesService, ActionManager, lodash) {
        return {
            restrict: 'E',
            templateUrl: 'common/app/components/activities/activity-input/activity-add-attachment',
            link: function(scope) {
                const vm = scope.vm;
                const parentVm = scope.$parent.vm;

                scope.$on('onAddAttachmentClick', function () {
                    scope.onAddAttachmentClick();
                });

                scope.onAddAttachmentClick = function() {
                    const docLibOptions = lodash.get(parentVm, 'options.attachmentOptions', {});
                    ActionManager('open-document-library', docLibOptions).then(function(result) {
                        result.modal.closed.then(function(res) {
                            if (res !== false) {
                                // add to model
                                if (lodash.has(vm.model, 'attachments')) {
                                    vm.model.attachments = vm.model.attachments.concat(res);
                                } else {
                                    vm.model.attachments = res;
                                }
                            }
                        });
                    });
                }
            }
        };
    }
})();